// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.navbar-section-container {
  /* display: flex;
  justify-content: space-between;
  align-items: center;
  align-self: stretch; */

  background-color: #ffffff; /* bg-white */

  border-bottom: 1px solid #e2e8f0; /* border-b border-slate-200 */

  padding: 1.25rem 2rem; /* py-5 px-8 */

  display: flex; /* flex */
  align-items: center; /* items-center */
  justify-content: space-between; /* justify-between */

  width: 100%;
}

.navbar-section-left-div {
  display: flex;
  /* align-items: flex-start; */
  align-items: center;
  gap: 20px;
}

.header-subHeader-div {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 4px;
}

.headder-p {
  font-size: 1.5rem; /* text-2xl */
  line-height: 2rem; /* default line-height for text-2xl */

  font-weight: 700; /* font-bold */
  color: #0f172a; /* text-slate-900 */

  letter-spacing: -0.025em; /* tracking-tight */
}

.subHeadder-p {
  font-size: 0.875rem; /* text-sm */
  line-height: 1.25rem; /* default line-height for text-sm */
  color: #64748b; /* text-slate-500 */
}

.button-support-close {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  white-space: nowrap;
  font-size: 14px;
  font-weight: 500;
  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out;
  outline: none;
  border: 1px solid transparent;
  background: transparent;
  height: 24px;
  width: 24px;
  border-radius: 50%;
  cursor: pointer;
  padding: 20px 20px;
  box-sizing: border-box;
}

.button-support-close:hover {
  background-color: #f1f5f9;
}

.button-support-close svg {
  pointer-events: none;
  width: 16px;
  height: 16px;
  flex-shrink: 0;
  color: #64748b;
}
`, "",{"version":3,"sources":["webpack://./client/src/layouts/ecommerce/posnavbar/components/helpAndSupportDrawer/Component/NavBar/HelpAndSupportNavBar.css"],"names":[],"mappings":"AAAA;EACE;;;wBAGsB;;EAEtB,yBAAyB,EAAE,aAAa;;EAExC,gCAAgC,EAAE,8BAA8B;;EAEhE,qBAAqB,EAAE,cAAc;;EAErC,aAAa,EAAE,SAAS;EACxB,mBAAmB,EAAE,iBAAiB;EACtC,8BAA8B,EAAE,oBAAoB;;EAEpD,WAAW;AACb;;AAEA;EACE,aAAa;EACb,6BAA6B;EAC7B,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,uBAAuB;EACvB,QAAQ;AACV;;AAEA;EACE,iBAAiB,EAAE,aAAa;EAChC,iBAAiB,EAAE,qCAAqC;;EAExD,gBAAgB,EAAE,cAAc;EAChC,cAAc,EAAE,mBAAmB;;EAEnC,wBAAwB,EAAE,mBAAmB;AAC/C;;AAEA;EACE,mBAAmB,EAAE,YAAY;EACjC,oBAAoB,EAAE,oCAAoC;EAC1D,cAAc,EAAE,mBAAmB;AACrC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,8EAA8E;EAC9E,aAAa;EACb,6BAA6B;EAC7B,uBAAuB;EACvB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oBAAoB;EACpB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,cAAc;AAChB","sourcesContent":[".navbar-section-container {\n  /* display: flex;\n  justify-content: space-between;\n  align-items: center;\n  align-self: stretch; */\n\n  background-color: #ffffff; /* bg-white */\n\n  border-bottom: 1px solid #e2e8f0; /* border-b border-slate-200 */\n\n  padding: 1.25rem 2rem; /* py-5 px-8 */\n\n  display: flex; /* flex */\n  align-items: center; /* items-center */\n  justify-content: space-between; /* justify-between */\n\n  width: 100%;\n}\n\n.navbar-section-left-div {\n  display: flex;\n  /* align-items: flex-start; */\n  align-items: center;\n  gap: 20px;\n}\n\n.header-subHeader-div {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: flex-start;\n  gap: 4px;\n}\n\n.headder-p {\n  font-size: 1.5rem; /* text-2xl */\n  line-height: 2rem; /* default line-height for text-2xl */\n\n  font-weight: 700; /* font-bold */\n  color: #0f172a; /* text-slate-900 */\n\n  letter-spacing: -0.025em; /* tracking-tight */\n}\n\n.subHeadder-p {\n  font-size: 0.875rem; /* text-sm */\n  line-height: 1.25rem; /* default line-height for text-sm */\n  color: #64748b; /* text-slate-500 */\n}\n\n.button-support-close {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  white-space: nowrap;\n  font-size: 14px;\n  font-weight: 500;\n  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out;\n  outline: none;\n  border: 1px solid transparent;\n  background: transparent;\n  height: 24px;\n  width: 24px;\n  border-radius: 50%;\n  cursor: pointer;\n  padding: 20px 20px;\n  box-sizing: border-box;\n}\n\n.button-support-close:hover {\n  background-color: #f1f5f9;\n}\n\n.button-support-close svg {\n  pointer-events: none;\n  width: 16px;\n  height: 16px;\n  flex-shrink: 0;\n  color: #64748b;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
